import { Value } from 'interfaces';
const colorDecider = (value: Value): string => {
  let color;
  switch (value) {
    case 'LEAD':
      color = 'green';
      break;
    case 'IN_PROGRESS':
      color = 'orange';
      break;
    case 'MADE_OFFER':
      color = 'blue';
      break;
    case 'DEAL_CLOSED_SUCCESS':
      color = 'green';
      break;
    case 'DEAL_FAILED':
      color = 'red';
      break;
    default:
      color = '';
      break;
  }
  return color;
};
export default colorDecider;
